var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPainSurvey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 1.5H17.625L23.25 7.125V22.75",
    stroke: "#919B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 24.625V7.125C0.75 6.62772 0.947544 6.15081 1.29917 5.79917C1.65081 5.44754 2.12772 5.25 2.625 5.25H14.815C15.0138 5.25018 15.2045 5.32931 15.345 5.47L19.28 9.405C19.35 9.47488 19.4054 9.55789 19.4432 9.64928C19.4809 9.74067 19.5002 9.83862 19.5 9.9375V24.625C19.5 25.1223 19.3025 25.5992 18.9508 25.9508C18.5992 26.3025 18.1223 26.5 17.625 26.5H2.625C2.12772 26.5 1.65081 26.3025 1.29917 25.9508C0.947544 25.5992 0.75 25.1223 0.75 24.625Z",
    stroke: "#919B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.25V9.5C14.5 9.69891 14.579 9.88968 14.7197 10.0303C14.8603 10.171 15.0511 10.25 15.25 10.25H19.5",
    stroke: "#919B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainSurvey);
export default __webpack_public_path__ + "static/media/painSurvey.3ad0d574f3d759d8e8c9bce5f17a6555.svg";
export { ForwardRef as ReactComponent };